import React, {
  Component
}                     from 'react';
import PropTypes      from 'prop-types';
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Modal,
  ButtonGroup,
  DropdownButton,
  MenuItem,
  Checkbox
}                     from 'react-bootstrap';
import { withRouter } from 'react-router';
import { connect }    from 'react-redux';
import {
  bindActionCreators,
  compose
}                     from 'redux';
//import Alert          from '../../../components/alert/Alert';
import { createHashHistory } from 'history';
import {
  NewBreadcrumb as BreadcrumbComponent
}                        from '../../../components';

// include action file for add merchant
import '../../../style/subAdmin/SubAdmin.scss';
import { Notification } from '../../../components/notifications';
import isEmpty from 'lodash.isempty';
import { getSubscriberFile, importSubscriberList, disableFile } from '../../../redux/actions/emailManagerActions';
import {renderAlert, clearAlert} from '../../../redux/actions/alertsActions';
import moment from 'moment';
import loader from '../../../style/loader/loader.scss'; 
import { getCoutnryCity } from '../../../redux/actions/emailManagerActions';

import Dialog from 'react-bootstrap-dialog';

import Pagination from 'react-paginating';
import { CSVLink } from "react-csv";
const history = createHashHistory();

let rand = require("random-key");

const HorizontalLine = ({ }) => (
    <hr/>
);

const propTypes = {
    getSubscriberFile: PropTypes.func.isRequired,
};
import {aclUtil} from "../../util";
let cityItems=[];let isLoading="false",  csvData = [];
let cityID = [];
class ImportSubscriber extends Component {
  constructor(props){

    csvData = [
      [
        "Email",
      ],
      [
        "demo@example.com",
      ]
    ];

    super(props);
    this.state={
      path: ['Home', 'Import Subscriber'], 
      links: ["home",'import-subscriber'],
      disabled: false,
      cityID: '',
      isLoading: 'false',
      fileList: '',
      alertMessage: '',
      show: false,
      totalRecords: 0,
      perPage: 0,
      limit:25,
      currentPage: 1,
      pageCount:0,
      csvData: csvData,
      selectedFile: '',
      cityList: '',
      cityID: '',
      cityError: false,
      allCheck: false,
      allCity: 'no',
    }

    this.validate=this.validate.bind(this);
    this.handleSubmit=this.handleSubmit.bind(this);
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.Clear=this.Clear.bind(this);

    this.handleFormData = this.handleFormData.bind(this);
  }

 handleFormData(event) {
    this.setState({ selectedFile: event.target.files });
  }

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  validate = () => { 
    let isError = false;
    const errors = {};
  
    return isError;

  }

  validate = (e) => {
    let isError = false;
    if(this.state.cityID.length == 0 && this.state.allCity == 'no'){
      isError = true;
      this.setState({cityError: true});
    }else{
      this.setState({cityError: false});
    }

    return isError;
  }

  handleUnsubscribeSubmit = (e) => {
    e.preventDefault();
    let isError = this.validate();
    if(!isError){
      if(this.state.selectedFile !== ''){
        let images = this.state.selectedFile;
        const formData = new FormData();
        formData.append("file", images[0]);
        formData.append("allCity", this.state.allCity);
        formData.append("cityID", (this.state.cityID) ? JSON.stringify(this.state.cityID) : []);
        formData.append("site_id", localStorage.getItem("siteID"));
        this.props.importSubscriberList(formData, 'subscribers/upload-file-to-unsubscribe');
        isLoading="true";
      }else{
        alert('Please choose a file.');
      }
    }
  }

  handleSubmit(e){
    e.preventDefault();
    let isError = this.validate();
    if(!isError){
      if(this.state.selectedFile !== ''){
        let images = this.state.selectedFile;
        const formData = new FormData();
        formData.append("file", images[0]);
        formData.append("allCity", this.state.allCity);
        formData.append("cityID", (this.state.cityID) ? JSON.stringify(this.state.cityID) : []);
        formData.append("site_id", localStorage.getItem("siteID"));
        this.props.importSubscriberList(formData, 'subscribers/upload-file-to-subscribe');
        isLoading="true";
      }else{
        alert('Please choose a file.');
      }
    }
  }

  handleSaveFile = (e) => {
    if(this.state.selectedFile !== ''){
      let images = this.state.selectedFile;
      const formData = new FormData();
      formData.append("file", images[0]);
      formData.append("site_id", localStorage.getItem("siteID"));
      this.props.importSubscriberList(formData, 'subscribers/import-subscribers');
      isLoading="true";
    }else{
      alert('Please choose a file.');
    }
  }

  Clear = () => {
    this.state.selectedFile = "";
  }


  handlePageChange = page => {
    cityID = [];
    isLoading="true";
    this.setState({
      currentPage: page
    });
    this.props.getSubscriberFile({page:page,limit: this.state.limit, site_id: localStorage.getItem("siteID")});
    this.props.getCoutnryCity({site_id: localStorage.getItem("siteID")});
    this.setState({allCheck : false, allCity: 'no', cityID: cityID, site_id: localStorage.getItem("siteID")})
    // this.props.getSiteCity();
  };


  componentWillMount(){
    this.props.clearAlert ();
    this.handleDismiss();
    this.handlePageChange();
    this.props.getCoutnryCity({site_id: localStorage.getItem("siteID")});
  }

  handleCityData = (e) => {
    cityID = (this.state.cityID) ? this.state.cityID : [];
    let index;

    if (e.target.checked) {
      cityID.push(e.target.value);
    } else {
      index = cityID.indexOf(e.target.value)
      cityID.splice(index, 1)
    }
    this.setState({cityError: false});
    this.setState({cityID : cityID});
  }

  handleAllCheck = (e) => {
    if (e.target.checked) {
        cityID = [];
        if(this.state.cityList){
          this.state.cityList.map((data, index) =>
            data.cities.map((cityData, index) =>
              cityID.push(cityData.cityID)
            )
          )
        }
      this.setState({allCheck : true, allCity: 'yes',  cityError: false, cityID: cityID  });
    } else {
      cityID = [];
      this.setState({allCheck : false, allCity: 'no', cityID: cityID });
    }
  }

  componentWillReceiveProps(nextProps){     
      if(this.props.error !== nextProps.error){
        if(nextProps.error){
          this.props.clearAlert ();
          this.handleShow();
          this.props.renderAlert('warning',nextProps.error);
          isLoading="false";
        }
      } 

      if(this.props.importStatus !== nextProps.importStatus){
        if(nextProps.importStatus){
          this.props.clearAlert ();
          this.handleShow();
          this.props.renderAlert('success', nextProps.importStatus.message);
          isLoading="false";
          this.handlePageChange();
          window.scrollTo(0, 0);
        }
      }

      if(this.props.cityList !== nextProps.cityList){
        if(nextProps.cityList){
          isLoading = "false";
          this.setState({cityList: nextProps.cityList.data});
        }
      } 

      if(this.props.disableStatus !== nextProps.disableStatus){
        if(nextProps.disableStatus){
          this.props.clearAlert ();
          this.handleShow();
          this.props.renderAlert('success', nextProps.disableStatus.message);
          isLoading="false";
          this.handlePageChange();
          window.scrollTo(0, 0);
        }
      }

      

      if(this.props.subscriberList !== nextProps.subscriberList){
        if(nextProps.subscriberList){
          isLoading="false";
          const setPageCount = nextProps.subscriberList.data.total / nextProps.subscriberList.data.per_page;
          this.setState({fileList: nextProps.subscriberList.data, totalRecords:nextProps.subscriberList.data.total, perPage:nextProps.subscriberList.data.per_page, pageCount:setPageCount})
        }
      }

      if(nextProps.message){
        this.handleShow();
        this.setState({alertMessage:nextProps.message, msgType:nextProps.alertType})
      }
     
  }

  handleDisable = (e) => {
    let fileID = e.target.attributes.getNamedItem('data-key').value;
    this.dialog.show({
      body: "Are you sure you want to disable this?",
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          this.confirmDelete(fileID);
        })
      ]
    });
  }

  confirmDelete = (fileID) => {
    isLoading="true";
    this.props.disableFile(fileID);
  }

  render() {
    const { currentPage,totalRecords,perPage,pageCount } = this.state
   
    return (
      <div className="col-lg-12 add-sub-admin">
        <Dialog ref={(el) => { this.dialog = el }} />
        {(isLoading =='true') ? 
          <div className="loader">
            <p className="loading-message">
            <i>
                Loading...
            </i>
            </p>
            <div className="spinner">
                <div className="dot1"></div>
                <div className="dot2"></div>
            </div>
          </div> : ''
        }
       
        <div className="row">
          <div className="col-xs-12">
             <BreadcrumbComponent path={this.state.path} links={this.state.links}/>
          </div>
        </div>
        
        <form onSubmit={this.handleSubmit}>
        <div className="panel">
          <header className="panel-heading">Import Subscriber</header>
          <div className="panel-body">
            {this.state.show && this.state.alertMessage !=='' &&  
              <Row>      
                <div className="col-lg-12">
                  <Alert bsStyle={this.state.msgType} onDismiss={this.handleDismiss}>
                  <strong>{this.state.msgType}:</strong> {this.state.alertMessage}
                </Alert>
                </div>
              </Row>
            }
            <Row>
                <Col md={12} xs={12}>
                  <ControlLabel>Cities: <span className="text-danger">{(this.state.cityError) ? '(Please select city.)' : ''}</span></ControlLabel>
                </Col>
                <Col md={12} xs={12}>
                  {(this.state.allCheck) ?
                  <Checkbox value="all" checked={true} onClick={this.handleAllCheck}>Select All City</Checkbox>
                  :
                  <Checkbox value="all" onClick={this.handleAllCheck}>Select All City</Checkbox>
                  }
                </Col>
            </Row>
            {(this.state.cityList) &&
              this.state.cityList.map((data, index) =>
                <Row>
                <Col md={12} xs={12}><b>{(data.cities.length != 0) ? data.country : ''}</b></Col>
                  <Col md={12} xs={12}>
                    <Row>
                    {data.cities.map((cityData, index) => 

                        <Col md={4} xs={12} key={Math.random() + index}>
                          {(cityID.indexOf(JSON.stringify(cityData.cityID)) > -1) ?
                          // <div>check</div>
                          <Checkbox onClick={this.handleCityData} defaultChecked={true} value={cityData.cityID}>{cityData.title}</Checkbox>
                          :
                          <Checkbox onClick={this.handleCityData} checked={this.state.allCheck}  value={cityData.cityID}>{cityData.title}</Checkbox>
                          }
                        </Col>
                      )
                    }
                    </Row>
                  </Col>
                </Row>
              )
            }
            <Row>
              <Col md={6} xs={12}>
                  <FormGroup>
                    <ControlLabel>Upload Email Lists for sending out Alerts </ControlLabel>
                    <FormControl
                      type="file"
                      id="file"
                      onChange={this.handleFormData}
                    />
                  </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6} xs={12}>
                {this.state.csvData ? (
                <CSVLink
                  data={this.state.csvData}
                  filename={"demoCSV.csv"}
                  className="btn btn-default"
                >
                Download your demo CSV
                  </CSVLink>
                ) : null}
                <Button bsStyle="success" onClick={this.handleSubmit}>Subscribe</Button>
                {aclUtil.checkACL('IMPORT_UNSUBSCRIBER') ? (<Button bsStyle="danger" onClick={this.handleUnsubscribeSubmit}>Unsubscribe</Button>) :("")}
                <Button bsStyle="warning" onClick={this.handleSaveFile}>Save your file</Button>
              </Col>
            </Row>
            
          </div>
        </div> 
        </form>
        {/**end contract information **/}

        <div className="panel">
          <div className="panel-body">
          <table className="table table-hover table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>File Name</th>
                <th>Uploaded Date</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
                {(!isEmpty(this.state.fileList.data)) ? 
                  this.state.fileList.data.map((data, index) => 
                    <tr key={index}>
                      <td>{++index}</td>
                      <td>{data.fileName}</td>
                      <td> 
                       {moment(data.created_at).format("MM-DD-YYYY HH:mm:ss")}
                      </td>
                      <td>
                        <ButtonGroup>
                          <DropdownButton title="Action" id="bg-nested-dropdown">
                            <MenuItem eventKey={Math.random()} data-key={data.fileID} href={data.fileLink}><i className="fa fa-download"></i> Download</MenuItem>
                            <MenuItem eventKey={Math.random()} data-key={data.fileID} onClick={this.handleDisable}><i className="fa fa-trash"></i> Disable</MenuItem>
                          </DropdownButton>
                      </ButtonGroup>
                      </td>
                    </tr>
                  )
                :
                <tr><td colSpan="6" className="text-center">Data Not Found</td></tr>
                }
            </tbody>
          </table>
          <div className="text-center">
                <Pagination
                  total={totalRecords}
                  limit={perPage}
                  pageCount={pageCount}
                  currentPage={currentPage}
                >
                  {({
                    pages,
                    currentPage,
                    hasNextPage,
                    hasPreviousPage,
                    previousPage,
                    nextPage,
                    totalPages,
                    getPageItemProps
                  }) => (
                    <div className="pagination">
                      <button
                        {...getPageItemProps({
                          pageValue: 1,
                          onPageChange: this.handlePageChange
                        })}
                      >
                        first
                      </button>

                      {hasPreviousPage && (
                        <button
                          {...getPageItemProps({
                            pageValue: previousPage,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          {'<'}
                        </button>
                      )}

                      {pages.map(page => {
                        let activePage = null;
                        if (currentPage === page) {
                          activePage = { backgroundColor: '#ccc', color: '#666' };
                        }
                        return (
                          <button
                            key={page}
                            style={activePage}
                            {...getPageItemProps({
                              pageValue: page,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {page}
                          </button>
                        );
                      })}

                      {hasNextPage && (
                        <button
                          {...getPageItemProps({
                            pageValue: nextPage,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          {'>'}
                        </button>
                      )}

                      <button
                        {...getPageItemProps({
                          pageValue: totalPages,
                          onPageChange: this.handlePageChange
                        })}
                      >
                        last
                      </button>
                    </div>
                  )}
                </Pagination>
                </div>
          </div>
        </div>       
      </div>
    );
  }
}
 
 

const mapStateToProps = (state,ownProps) => {
    return {
      error: state.emailManagerReducer.error,
      alertType: state.alertsReducer.alertType,
      message: state.alertsReducer.message,
      subscriberList:  state.emailManagerReducer.subscriberList,
      importStatus:  state.emailManagerReducer.importStatus,
      disableStatus:  state.emailManagerReducer.disableStatus,
      cityList:  state.emailManagerReducer.cityList,
    };
};

export default compose(
  withRouter, 
  connect(mapStateToProps, {renderAlert, clearAlert, getSubscriberFile, importSubscriberList, disableFile, getCoutnryCity})
)(ImportSubscriber);



// WEBPACK FOOTER //
// ./src/app/views/admin/EmailManager/ImportSubscriber.js